<script>
  import {
    userMethods,
    statusGetters,
    windowsComputed,
  } from '@state/helpers'
  import {
    doesUserHavePermission,
  } from '@utils/permissions'

  export default {
    props: {
      adminPermission: {
        type: null,
        required: true,
      },
      getStatuses: {
        type: null,
        default: null,
      },
      defaultFilters: {
        type: Array,
        default: () => [],
      },
      collapse: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        statuses: [],
        statusesAdmin: [],
        toggleFilters: true,
        boundCollapse: false,
      }
    },
    computed: {
      ...windowsComputed,
      filters(){
        const partA = this.statuses.map(el => {
          if (el.selected){
            return el.key
          }
        }).filter(el => el)
        const partB = this.statusesAdmin.map(el => {
          if (el.selected){
            return el.key
          }
        }).filter(el => el)
        return [...partA, ...partB]
      },
    },
    watch: {
      filters (val) {
        this.$emit('filter', { statuses: val })
      },
    },
    async created() {
      // load options
      await this.loadStatuses()

      if (this.defaultFilters && this.defaultFilters.length > 0){
        this.defaultFilters.forEach(el => {
          const s = this.statuses.find(inner => inner.key === el);
          if (s) s.selected = true
          const sa = this.statusesAdmin.find(inner => inner.key === el);
          if (sa) sa.selected = true
        })
      }
    },
    methods: {
      ...statusGetters,
      ...userMethods,
      doesUserHavePermission,
      async loadStatuses () {
        if (typeof this.getStatuses !== 'function') {
          return
        }
        const { data } = await this.getStatuses()
        data.forEach(el => el.selected = false)
        await this.splitStatuses(data)
      },
      async splitStatuses(data){
        let basicStatuses = [...data]
        basicStatuses = basicStatuses.filter( el => (
          this.getAdminStatuses().findIndex(element => (el.key === element)) === -1
        )
        )
        this.statuses = basicStatuses

        let adminStatuses = [...data]
        adminStatuses = adminStatuses.filter( el => (
          this.getAdminStatuses().findIndex(element => (el.key === element)) !== -1
        )
        )
        this.statusesAdmin = adminStatuses
      },
    },
  }
</script>

<template>
  <div v-if="statuses.length" class="block-item bg-white">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-status
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by status</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
          :default-collapsed="isTablet"
        />
      </h3>
      <FabricBadge
        :styling-bg="filters.length ? 'badge-primary' : 'badge-light'"
        :copy="filters.length"
      />
    </div>
    <FabricCollapse
      id="accordion-status"
      v-model="boundCollapse"
      hide-header
      :duration="500">
      <div class="block-content">
        <FabricCheckbox
          v-for="statusItem of statuses"
          :key="statusItem.key"
          v-model="statusItem.selected"
          slot-classes="tw-pl-3 tw-text-black"
        >{{ statusItem.name }}</FabricCheckbox>
        <section
          v-if="doesUserHavePermission( getUserPermissions(), adminPermission, getUserType() )">
          <FabricCheckbox
            v-for="statusItem of statusesAdmin"
            :key="statusItem.key"
            v-model="statusItem.selected"
            slot-classes="tw-pl-3 tw-text-black"
          >{{ statusItem.name }}</FabricCheckbox>
        </section>
      </div>
    </FabricCollapse>
  </div>
</template>
